















import {Component, Watch} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {CommonStatus} from "@/enums/status";
import {CustomerStore} from "@/modules/customers/store";
import debounce from "lodash/debounce";
import {listCustomer} from "@/modules/customers/services";
import {CustomerType} from "@/enums/type/customertype";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import TableToExcel from "@linways/table-to-excel";
import CustomerExcel from "@/modules/customers/List/components/Excel.vue";
import {CustomerRegisterStore} from "@/modules/customerregister/store";

@Component({
    name: "CustomerRegisterSearch",
    components: {CustomerExcel, PostOfficeSelector, EnumSelector}
})
export default class extends mixins(CommonMixin) {
    CommonStatus = CommonStatus;
    form = {
        search: "",
        postOfficeRowGuid: undefined
    };
    isExporting = false;
    
    @Watch('form', { immediate: false, deep: true })
    onValuesChange(val: any) {
        this.handleChange(val);
    }
    
    handleChange = debounce(function (val) {
        CustomerRegisterStore.updateCustomerRegisterParams(val);
        CustomerRegisterStore.listCustomerRegister({ ...val, page: 1 })
    }, 500);
    
}
